<script>
import lazyLoadComponent from '@router/lazyload-component'
const conditionList = (list) => {
  return list.filter(({condition})=>{
    if (condition) return condition()
    return true
  })
}

export default {
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => {},
    },
    defaultQuestions: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      activeTab: '0',
      tabList: Object.freeze(conditionList([
        {
          title: '美容訂單',
          component: () => lazyLoadComponent(import('./DetailOrdersProduct')),
        },
        //  FIX ME: 安親的時候要開放
        // {
        //   title: '安親訂單',
        //   component: () => lazyLoadComponent(import('./DetailOrdersProduct')),
        // },
      ])),
    }
  },
  methods: {
    backToList() {
      this.$emit('back')
    },
  },
}
</script>

<template>
  <div :class="$style.page">
    <!-- <BasePageHeader title="預約紀錄">
      <template v-slot:right>
        <el-tabs v-model="activeTab" type="border-card" stretch class="isStyleBase">
          <el-tab-pane
            v-for="(tab, index) in tabList"
            :key="index"
            :label="tab.title"
            :name="`${index}`"
          ></el-tab-pane>
        </el-tabs>
      </template>
    </BasePageHeader> -->
    <el-tabs v-model="activeTab" type="border-card" stretch class="isStyleBase isSecond">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.title"
        :name="`${index}`"
      ></el-tab-pane>
    </el-tabs>
    <!-- <keep-alive> -->
      <component 
        :is="tabList[activeTab].component"
        :class="$style.pageContent"
        :default-value="defaultValue"
        :pet-value="`${defaultValue.id}`"
        @back="backToList"
      >
    </component>
    <!-- </keep-alive> -->
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
